import type { FilterOptionViewModel } from 'autogen/swagger/all';
import DefaultMenuItem from 'components/generic/menu/components/DefaultMenuItem';
import Radio from 'components/shared/inputs/radio/RadioInput';
import React, { memo } from 'react';
import useGA4Tracking from 'modules/tracking/GA4';
import useFilters from '../../../shared/hooks/useFilters';

const SortingFilterOption = ({
    model: { displayName, isSelected: initialIsSelected, queryStringName, value }
}: {
    model: FilterOptionViewModel;
}) => {
    const ga4Tracking = useGA4Tracking();
    const { removePendingFilter, updatePendingFilter, isPendingFilterValueActive, isPendingFilterActive } =
        useFilters();

    const handleSortingChange = () => {
        // if no value it's the default option
        if (!value) {
            removePendingFilter(queryStringName); // we need to remove the querySearchParam since it's the default option
        } else {
            updatePendingFilter(queryStringName, value);
        }
    };

    const isSelected = () => {
        // if no value it's the default option
        if (!value) {
            return !isPendingFilterActive(queryStringName); // if there's no pending sort querySearchParam that means default sort is selected
        }
        return isPendingFilterValueActive(queryStringName, value);
    };

    const afterSlot = <Radio readOnly checked={isSelected()} />;

    return (
        <DefaultMenuItem.Button
            buttonProps={{
                onClick: () => {
                    handleSortingChange();
                    ga4Tracking({
                        eventName: 'select_filter',
                        category: 'ecommerce',
                        eventParams: [
                            { param_name: 'list_name', param_value: displayName },
                            { param_name: 'filter_name', param_value: value || 'standard' },
                            { param_name: 'filter_list_name', param_value: queryStringName }
                        ]
                    });
                }
            }}
            afterSlot={afterSlot}
        >
            {displayName}
        </DefaultMenuItem.Button>
    );
};
export default memo(SortingFilterOption);
